import { Typography } from '@mui/material'
import { MESSAGES } from './chrome/chartChrome'

interface Props {
  count: number
}

/** Row 18: visible indicator for trailing points excluded from the sub-period panels
 *  (window not divisible by panel size). The loud counterpart to
 *  partitionWithRemainder's `hidden` — silent dropping is not acceptable. */
export function HiddenRemainderNote({ count }: Props) {
  if (count === 0) return null
  return (
    <Typography variant="caption" color="text.secondary">
      {MESSAGES.hiddenRemainder(count)}
    </Typography>
  )
}
